import { useAuth } from "../../components/context/Auth";
import {
  ManagerSortByIcon,
  ManagerWareHouseIcon,
  TestTopAddDealerIcon,
} from "../../components/icons/Icon";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./ManagerJsx.module.css";
import DealerInfoCard from "../../components/updatedComponents/Dealers/DealerInfoCard";
import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
import Button from "../../components/updatedComponents/Dealers/Button";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import fetchData from "../../APIsControll/apiControll";
import GoToPage from "../../components/updatedComponents/Pagnation/GoToPage";
import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import ManagerDevicesTable from "../../components/updatedComponents/Manager/ManagerDevicesTable";
import {
  RequestForDevice,
  TemplateNotFound,
} from "../../components/icons/Icon2";
import LocationSarchFilter from "../../components/updatedComponents/Filter/LocationSarchFilter";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import {
  setCityData,
  setDistrictData,
  setIsstatus,
  setPage,
  setSelectDesignation,
  setSelectWarehouseId,
  setStateData,
} from "../../store/slices/managers/ManagersSlice";

const Managers = () => {
  const { mode, managerId } = useAuth();
  const containerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [managersData, setManagersData] = useState([]);
  const [managersData1, setManagersData1] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(1);
  const [showAllRequest, setShowallRequest] = useState(false);
  const [requestLength, setRequestLength] = useState(0);
  const [allDesignations, setAllDesignations] = useState([]);
  const [AllWarehouse, setAllWarehouse] = useState([]);
  const [sarch, setSearch] = useState("");
  const {
    Isstatus,
    page,
    state,
    district,
    city,
    selectDesignation,
    selectWarehouseId,
  } = useSelector((state) => state.managers);

  const dispatch = useDispatch();

  useEffect(() => {
    const getDealerLoction = async () => {
      try {
        const payload = {
          managerId: managerId,
          stateSearch: "",
          districtSearch: "",
          citySearch: "",
          pincodeSearch: "",
          locations: {
            states: [],
            districts: [],
            cities: [],
            pincodes: [],
          },
        };
        const res = await fetchData(`warehouses/filterLocation`, payload);

        dispatch(setDistrictData({ locationList: res?.data?.districts || [] }));
        dispatch(setStateData({ locationList: res?.data?.states || [] }));
        dispatch(setCityData({ locationList: res?.data?.cities || [] }));
      } catch (error) {}
    };
    getDealerLoction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId]);

  useEffect(() => {
    const getAllDesignations = async () => {
      try {
        const payload = { managerId };
        const AllDesignations = await fetchData(`managers/getAllDesignations`);
        const AllWarehouse = await fetchData(
          `warehouses/getAllWarehouse`,
          payload,
        );
        setAllDesignations(AllDesignations.data);
        setAllWarehouse(
          AllWarehouse.data.map((w) => ({
            label: w.warehousename,
            value: w.warehouseId,
          })),
        );
      } catch (error) {}
    };
    getAllDesignations();
  }, [managerId]);

  useEffect(() => {
    const fetchAllManagers = async () => {
      try {
        setLoading(true);
        const apiData = {
          managerId,
          keyword: sarch,
          warehouseId: selectWarehouseId,
          // warehousename: selectWarehousename,
          designation: selectDesignation,
          status:
            Isstatus.toLocaleLowerCase() === "all"
              ? ""
              : Isstatus.toLocaleLowerCase() === "disabled"
                ? "disable"
                : Isstatus.toLocaleLowerCase(),
          locations: {
            states: state.searchValue,
            districts: district.selectFilter,
            cities: city.selectFilter,
            pincodes: [],
          },
        };
        const endpoint = `managers/allManagersList?page=${page}&limit=${32}`;
        const result = await fetchData(endpoint, apiData);
        if (result.status === "success") {
          setManagersData(result?.data);
          setManagersData1(result);
          setPages(result.pages);
          if (page >= result.pages) {
          }
        }
        if (result.status === "failed") {
          setManagersData([]);
          dispatch(setPage(1));
        }
      } catch (error) {
        console.error("Error while fetching managers:", error);
      } finally {
        setLoading(false);
      }
    };

    if (managerId) {
      fetchAllManagers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    managerId,
    page,
    state.selectFilter,
    district.selectFilter,
    city.selectFilter,
    sarch,
    Isstatus,
    selectDesignation,
    selectWarehouseId,
    state.searchValue,
  ]);

  const formatText = (t) => {
    if (typeof t !== "string") {
      return t;
    }

    if (t === "superadmin") {
      return "Super Admin";
    }

    const baseName = t.replace(/manager$/, "");

    const capitalizedBaseName = baseName
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return capitalizedBaseName.trim();
  };

  const mangerStatusData = [
    { statusText: "All", statusItemCount: managersData1.total || 0 },
    {
      statusText: "Active",
      statusItemCount: managersData1.statusCounts?.active || 0,
    },
    {
      statusText: "Disabled",
      statusItemCount: managersData1.statusCounts?.disable || 0,
    },
  ];

  return (
    <>
      <ModalWrapper
        isOpen={showAllRequest}
        onClose={() => setShowallRequest(!showAllRequest)}
      >
        <ManagerDevicesTable
          setRequestLength={setRequestLength}
          modelTogele={showAllRequest}
        />
      </ModalWrapper>

      <div
        style={
          mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}
        }
        className={styles.mgx}
      >
        <div className={styles.mgx_top}>
          <TopTabBar
            text={location.pathname.slice(1, location.pathname.length)}
          />
          <div className={styles.mgx_top_right}>
            <div className={styles.mgx_add_manager_btn}>
              <Button
                buttonIcon={<RequestForDevice />}
                buttonText={"Request"}
                buttonBgColor={"#000"}
                buttonTextColor={"#ffffff"}
                buttonBorder={"none"}
                buttonClick={() => setShowallRequest(!showAllRequest)}
                notify={requestLength === 0 ? false : true}
                count={requestLength}
              />
            </div>
            <div className={styles.mgx_add_manager_btn}>
              <Button
                buttonIcon={<TestTopAddDealerIcon />}
                buttonText={"Add Manager"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#ffffff"}
                buttonBorder={"none"}
                buttonClick={() => {
                  navigate("/managers/newmanager");
                }}
              />
            </div>
          </div>
        </div>

        <div className={styles.mgx_mob_filters}>
          <div className={styles.mgx_mob_filters_top}>
            <div style={{ width: "40%" }}>
              <SearchBar
                placeholder={"Search Managers"}
                padding={"3px"}
                fontSize={"12px"}
                fontWeight={"300"}
                borderRadius={"5px"}
                onChange={(event) => setSearch(event.target.value)}
              />
            </div>
            <ManagerWareHouseIcon />
            <ManagerSortByIcon />
            <div>
              <Button
                buttonIcon={<TestTopAddDealerIcon />}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#ffffff"}
                buttonBorder={"none"}
                buttonClick={() => {
                  navigate("/managers/newmanager");
                }}
              />
            </div>
          </div>
          <div style={{ height: "10px" }}></div>
          <div className={styles.mgx_mob_filters_top}>
            <DropDown label={"State"} />
            <DropDown label={"District"} />
            <DropDown label={"City"} />
          </div>
        </div>

        <div
          className={styles.mgx_middle}
          style={
            mode ? { backgroundColor: "#232529", borderColor: "#232529" } : {}
          }
        >
          {mangerStatusData.map((status) => (
            <div
              key={status.statusText}
              className={`${styles.receipts_filter} ${
                mode ? styles.receipts_filter_dark : ""
              } ${
                status.statusText === Isstatus
                  ? mode
                    ? styles.receipts_filter_active_dark
                    : styles.receipts_filter_active
                  : ""
              }`}
              onClick={() => dispatch(setIsstatus(status.statusText))}
            >
              <DealerStatusCard
                statusText={status.statusText}
                statusItemCount={status.statusItemCount}
              />
            </div>
          ))}
        </div>

        <div
          className={styles.mgx_bottom}
          style={mode ? { backgroundColor: "#2C2E33" } : {}}
        >
          <div className={styles.mgx_top} style={{ marginBottom: "10px" }}>
            <div>
              <SearchBar
                padding={"6px"}
                fontSize={"12px"}
                fontWeight={"400"}
                borderRadius={"5px"}
                placeholder={"Search Managers"}
                onChange={(event) => setSearch(event.target.value)}
              />
            </div>

            <div className={styles.mgx_top_right}>
              <DropDown
                label={"Designation"}
                options={allDesignations?.map((e) => ({
                  label:
                    formatText(
                      e.designation.charAt(0).toUpperCase() +
                        e.designation.slice(1).toLowerCase(),
                    ) + " Manager",
                  value: e.designation,
                }))}
                listLabel={selectDesignation}
                onSelect={(value) =>
                  dispatch(setSelectDesignation(value.value))
                }
                onReject={() => dispatch(setSelectDesignation(""))}
              />
              <LocationSarchFilter
                text={"State"}
                list={state.locationList}
                search={state.searchValue}
                setSearch={(value) =>
                  dispatch(setStateData({ locationList: value }))
                }
                selectFilter={state.selectFilter}
                setSelectFilter={(value) =>
                  dispatch(setStateData({ locationList: value }))
                }
              />
              <LocationSarchFilter
                text={"District"}
                list={district.locationList}
                search={district.searchValue}
                setSearch={(value) =>
                  dispatch(setDistrictData({ locationList: value }))
                }
                selectFilter={district.selectFilter}
                setSelectFilter={(value) =>
                  dispatch(setDistrictData({ locationList: value }))
                }
              />
              <LocationSarchFilter
                text={"City"}
                list={city.locationList}
                search={city.searchValue}
                setSearch={(value) =>
                  dispatch(setCityData({ locationList: value }))
                }
                selectFilter={city.selectFilter}
                setSelectFilter={(value) =>
                  dispatch(setCityData({ locationList: value }))
                }
              />
              <DropDown
                label={"Warehouse"}
                options={AllWarehouse}
                listLabel={selectWarehouseId}
                onSelect={(value) =>
                  dispatch(setSelectWarehouseId(value.value))
                }
                onReject={() => dispatch(setSelectWarehouseId(""))}
              />
            </div>
          </div>

          <div className={styles.maindivscroll}>
            <div
              className={styles.mgx_data}
              style={mode ? { backgroundColor: "#2C2E33" } : {}}
              ref={containerRef}
            >
              {loading ? (
                Array.from({ length: 24 }).map((_, index) => (
                  <div key={index} style={{ width: "100%" }}>
                    <Skeleton
                      thickness={6}
                      shape="circle"
                      width="50px"
                      height="50px"
                    />
                    <div style={{ width: "75%" }}>
                      <Skeleton lines={2} thickness={1} />
                    </div>
                    <Skeleton lines={1} thickness={3} />
                  </div>
                ))
              ) : managersData.length === 0 ? (
                <>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <NoDataFound
                      icon={<TemplateNotFound />}
                      to={"/templates/template"}
                    />
                  </div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </>
              ) : (
                managersData.map((item, i) => (
                  <div
                    className={styles.mgx_manager_card}
                    key={i}
                    onClick={() => {
                      navigate("/managers/manager?manager_Id=" + item._id);
                    }}
                  >
                    <DealerInfoCard
                      dealerName={item.name}
                      dealerStatus={item.status}
                      dealerDesignation={item.designation
                        .map((d) => formatText(d))
                        .join(", ")}
                      type={"manager"}
                    />
                  </div>
                ))
              )}
            </div>
          </div>

          <div style={{ width: "100%" }} className={styles.hide_700px}>
            <Skeleton thickness={6} shape="circle" width="50px" height="50px" />
            <div style={{ width: "75%" }}>
              <Skeleton lines={2} thickness={1} />
            </div>
            <Skeleton lines={1} thickness={3} />
          </div>
        </div>

        <div
          className={styles.mgx_pagination}
          style={{ backgroundColor: mode ? "#232529" : "#fff" }}
        >
          <div style={{ width: "50%" }}>
            <div
              style={{
                width: "50%",
                display: "flex",
                justifyContent: "flex-start",
                fontSize: "14px",
              }}
            >
              <GoToPage
                currentPage={page}
                setCurrentPage={(num) => dispatch(setPage(num))}
                totalPages={pages}
                key={"1"}
              />
            </div>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              fontSize: "12px",
            }}
          >
            <Pagenation
              currentPage={page}
              setCurrentPage={(num) => dispatch(setPage(num))}
              totalPages={pages}
              key={"1"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Managers;
